import { Col, Form, Row, Space } from "antd";
import {
  CAMPAIGN_TYPE,
  COMBO_CAMPAIGN,
  DISCOUNT_TYPE,
  PRODUCT_TYPE,
  PROMOTION_CAMPAIGN_TYPE,
  TYPE_LIMIT,
} from "features/Campaign/constants";
import { convertConditionProductGroups } from "hooks/campaign/converter";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import ButtonGroup from "./components/ButtonGroup";
import CampaignInfo from "./components/CampaignInfo";
import ConditionInfo from "./components/ConditionInfo";
import MarketingInfo from "./components/MarketingInfo";
import ModalSelectComboCampaign from "./components/ModalSelectComboCampaign";
import DiscountMoneyForm from "./DiscountMoneyForm";
import FixedPriceForm from "./FixedPriceForm";
import GiftForm from "./GiftForm";
import OneOnProductForm from "./OneOnProductForm";

import { getQuery } from "utils/helperFuncs";
import "./index.scss";
import { OrderPromoForm } from "./OrderPromoForm";

const initFormDiscountMoney = {
  type: COMBO_CAMPAIGN.DISCOUNT_MONEY,
  promotionCampaignTiers: [
    {
      type: COMBO_CAMPAIGN.DISCOUNT_MONEY,
      minQuantity: null,
      maxQuantityPerSeller: null,
      discountType: DISCOUNT_TYPE.DISCOUNT_MONEY,
      discountAmount: null,
      budgetAmount: null,
      conditionProductGroups: [{ quantity: null, conditionPromotionProducts: [] }],
      limitType: TYPE_LIMIT.LIMIT,
    },
  ],
};

const initFormFixedPrice = {
  type: COMBO_CAMPAIGN.FIXED_PRICE,
  maxQuantityPerSeller: null,
  budgetProductQuantity: null,
  limitType: TYPE_LIMIT.LIMIT,
  promotionCampaignTiers: [
    {
      conditionProductGroups: [{ quantity: null, conditionPromotionProducts: [] }],
      fixedComboPrice: null,
      type: COMBO_CAMPAIGN.FIXED_PRICE,
    },
  ],
};

const initFormGift = {
  type: COMBO_CAMPAIGN.GIFT,
  maxQuantityPerSeller: null,
  budgetProductQuantity: null,
  limitType: TYPE_LIMIT.LIMIT,
  promotionCampaignTiers: [
    {
      type: COMBO_CAMPAIGN.GIFT,
      maxQuantityPerSeller: null,
      limitType: TYPE_LIMIT.LIMIT,
      conditionProducts: [
        {
          type: PRODUCT_TYPE.CONDITION_PRODUCT,
          quantity: null,
          conditionPromotionProducts: [],
        },
      ],
      conditionGifts: [
        {
          type: PRODUCT_TYPE.GIFT_PRODUCT,
          quantity: null,
          conditionPromotionProducts: [],
        },
      ],
    },
  ],
};

const CampaignForm = ({
  handleValuesChange,
  isApplyWithPromotion,
  promoType,
  initialValues,
  handleCheckIsApplyWithPromo,
  form,
  loadingCheckDuplicateCodes,
  promotionCampaignTiers,
  dataConfirmModal,
  visibleConfirmModal,
  handleOpenConfirmModal,
  handleCancelConfirmModal,
  handleActionCampaign,
  createLoading,
  indexErrorCombo,
  isUpdate,
  isEditMode,
  dataCampaign,
  loadingUpdate,
  handleProductDataSourceChange,
  promotionCampaignID: promotionCampaignIDProp,
}) => {
  const GET_QUERY = getQuery();

  const [selectedValueComboButtons, setSelectedValueComboButtons] = useState([]);
  const [dataGift, setDataGift] = useState([]);
  const [dataDiscountMoney, setDataDiscountMoney] = useState([]);
  const [dataFixedPrice, setDataFixedPrice] = useState([]);
  const [dataDiscountProduct, setDataDiscountProduct] = useState([]);

  const handleGetData = (value) => {
    setDataGift(value);
    setDataDiscountMoney(value);
    setDataFixedPrice(value);
  };

  const handleRemoveValueComboSelected = (valueToRemove) => {
    const updatedData = selectedValueComboButtons.filter((item) => item !== valueToRemove);
    setSelectedValueComboButtons(updatedData);
  };

  const handleGetValueComboButtons = (value) => {
    setSelectedValueComboButtons(value);
  };

  const isComboType = (type) => selectedValueComboButtons.includes(type);

  const isComboDiscountMoney = isComboType(COMBO_CAMPAIGN.DISCOUNT_MONEY);
  const isComboGift = isComboType(COMBO_CAMPAIGN.GIFT);
  const isComboFixedPrice = isComboType(COMBO_CAMPAIGN.FIXED_PRICE);

  useEffect(() => {
    const tierGroups = dataCampaign?.promotionCampaignTierGroups;
    const isComboTypeInServer = (type) => tierGroups?.some((item) => item.type === type);
    const getDataTiersServer = (type) => {
      const newData = cloneDeep(tierGroups);
      return newData?.filter((item) => item.type === type) || [];
    };

    const newArray = [
      isComboTypeInServer(COMBO_CAMPAIGN.DISCOUNT_MONEY) ? COMBO_CAMPAIGN.DISCOUNT_MONEY : undefined,
      isComboTypeInServer(COMBO_CAMPAIGN.GIFT) ? COMBO_CAMPAIGN.GIFT : undefined,
      isComboTypeInServer(COMBO_CAMPAIGN.FIXED_PRICE) ? COMBO_CAMPAIGN.FIXED_PRICE : undefined,
    ];
    setDataGift(convertConditionProductGroups(tierGroups));
    setDataDiscountMoney(getDataTiersServer(COMBO_CAMPAIGN.DISCOUNT_MONEY));
    setDataFixedPrice(getDataTiersServer(COMBO_CAMPAIGN.FIXED_PRICE));
    setDataDiscountProduct(getDataTiersServer(COMBO_CAMPAIGN.DISCOUNT_PRODUCT));
    setSelectedValueComboButtons(newArray);
  }, [dataCampaign?.promotionCampaignTierGroups]);

  // useEffect(() => {
  //   if (isUpdate) {
  //     history.push(`${location.pathname}#${dataCampaign?.campaignType}`);
  //   }
  // }, [JSON.stringify(dataCampaign?.campaignType)]);

  return (
    <Form initialValues={initialValues} form={form} colon={false} layout="vertical" onValuesChange={handleValuesChange}>
      <Space direction="vertical" size={14} style={{ width: "100%" }} className="custom-collapse">
        <Row gutter={[16, 8]} className="campaign-info-marketing-row">
          <Col span={7}>
            <CampaignInfo
              form={form}
              isApplyWithPromotion={isApplyWithPromotion}
              handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
              isUpdate={isUpdate}
            />
          </Col>
          <Col span={17}>
            <MarketingInfo form={form} />
          </Col>
        </Row>
        {promoType === PROMOTION_CAMPAIGN_TYPE.TOP_SALES && <ConditionInfo />}
        {isComboDiscountMoney && selectedValueComboButtons?.length ? (
          <DiscountMoneyForm
            dataTiersServer={dataDiscountMoney}
            handleRemoveValueComboSelected={handleRemoveValueComboSelected}
            form={form}
            promotionCampaignTiers={promotionCampaignTiers}
            indexErrorCombo={indexErrorCombo}
            isUpdate={isUpdate}
            onGetDataDiscountMoney={handleGetData}
            initFormDiscountMoney={initFormDiscountMoney}
          />
        ) : null}
        {isComboGift && selectedValueComboButtons?.length ? (
          <GiftForm
            dataTiersServer={dataGift}
            handleRemoveValueComboSelected={handleRemoveValueComboSelected}
            form={form}
            promotionCampaignTiers={promotionCampaignTiers}
            indexErrorCombo={indexErrorCombo}
            isUpdate={isUpdate}
            initFormGift={initFormGift}
            onGetDataGift={handleGetData}
          />
        ) : null}
        {isComboFixedPrice && selectedValueComboButtons?.length ? (
          <FixedPriceForm
            dataTiersServer={dataFixedPrice}
            handleRemoveValueComboSelected={handleRemoveValueComboSelected}
            form={form}
            promotionCampaignTiers={promotionCampaignTiers}
            indexErrorCombo={indexErrorCombo}
            isUpdate={isUpdate}
            initFormFixedPrice={initFormFixedPrice}
            onGetDataFixedPrice={handleGetData}
          />
        ) : null}
        {GET_QUERY.campaignType === CAMPAIGN_TYPE.COMBO_PROMO && (
          <ModalSelectComboCampaign
            form={form}
            initFormDiscountMoney={initFormDiscountMoney}
            initFormFixedPrice={initFormFixedPrice}
            initFormGift={initFormGift}
            onGetValueComboButtons={handleGetValueComboButtons}
            selectedValueComboButtons={selectedValueComboButtons}
            isDiscountMoney={isComboType(COMBO_CAMPAIGN.DISCOUNT_MONEY)}
            isGift={isComboType(COMBO_CAMPAIGN.GIFT)}
            isFixedPrice={isComboType(COMBO_CAMPAIGN.FIXED_PRICE)}
          />
        )}
        {(GET_QUERY.campaignType === CAMPAIGN_TYPE.PRODUCT_PROMO ||
          GET_QUERY.campaignType === CAMPAIGN_TYPE.CASH_DISCOUNT) && (
          <OneOnProductForm
            form={form}
            isUpdate={isUpdate}
            dataTiersServer={dataDiscountProduct}
            onDataSourceChange={handleProductDataSourceChange}
          />
        )}
        {GET_QUERY.campaignType === CAMPAIGN_TYPE.ORDER_PROMO && (
          <OrderPromoForm
            form={form}
            isUpdate={isUpdate}
            dataTiersServer={dataDiscountProduct}
            promotionCampaignID={promotionCampaignIDProp}
          />
        )}
      </Space>
      <div style={{ height: 6 }} />
      <ButtonGroup
        form={form}
        loadingCheckDuplicateCodes={loadingCheckDuplicateCodes}
        data={dataConfirmModal}
        visibleConfirmModal={visibleConfirmModal}
        handleOpenConfirmModal={handleOpenConfirmModal}
        handleCancelConfirmModal={handleCancelConfirmModal}
        handleActionCampaign={handleActionCampaign}
        createLoading={createLoading || loadingUpdate}
        isEditMode={isEditMode}
      />
    </Form>
  );
};

export default CampaignForm;
